module.exports = __webpack_public_path__ + "img/2.619ad0d8.png";